
import { defineComponent, ref, reactive, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import Descriptions from '@/components/descriptions.vue'
import Nodata from '@/components/page/nodata.vue'
import f10ApiHk from "@/api/f10ApiHk"

export default defineComponent({
  components: { Descriptions, Nodata },
  props: {

    itemdata: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    theme: {
      type: String,
      default: function () {
        return 'light'
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
  },
  setup(props: any) {
    const route = useRoute()
    const spinning = ref(true)
    const companyInfoDetail = ref<any>(null)
    const etfList = ref<any[]>([])

    const list = computed(() => {
      if (!companyInfoDetail.value) return []

      return [
        {
          title: '所属行业',
          key: 'industry',
          content: companyInfoDetail.value.industryName ? companyInfoDetail.value.industryName.split('-').pop() : '—'
        },
        {
          title: '所属ETF',
          key: 'etf',
          content: etfList.value.map(etf => `${etf.symbol_info.name}`).join('，') || '—'

        },
        {
          title: '主营业务',
          key: 'main_business',
          content: companyInfoDetail.value.mainOperationBusiness || '—',
          collapse: true
        }
      ]
    })
    function getResearchDetail() {

      spinning.value = true
      const data: any = {
        data: {
          // symbol: '00700',

          symbol: route.query.code || '00700',
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
        },
        headers: {

        },
      }
      f10ApiHk.getBriefbaseInfo2(data).then((res: any) => {
        console.log('我是所属ETF', res?.data)
        // 处理返回的ETF数据
        if (res?.data?.relate_etf?.list) {
          etfList.value = res.data.relate_etf.list
        }
        spinning.value = false
      }).catch(() => {
        spinning.value = false
      })

    }
    onMounted(() => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
      const data = {
        data: {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/no-unnecessary-boolean-literal-compare
          // market: 'HK' || route.query.market,
          // // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/no-unnecessary-boolean-literal-compare
          // symbol: '00700' || route.query.symbol
          market: route.query.market || 'HK',
          symbol: route.query.code || '00700',
        },
        // @ts-ignore
        headers: { token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944' }
      }

      f10ApiHk.getBriefDetail(data)
        .then(res => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
          companyInfoDetail.value = (res as any).data && (res as any).data.companyInfoDetail
        })
        .catch(console.error)
        .finally(() => spinning.value = false)


      getResearchDetail()


    })

    return { spinning, list }
  }
})
/* eslint-enable */
